import $ from 'jquery';
window.$ = window.jQuery = $;

var Modal = {
  init: function () {
    $(document).on('keyup', 'body', function (e) {
      if (e.keyCode === 27) {
        $('.modal-close-trigger').click();
      }
    });

    $(document).on('click', '.modal-trigger', function (e) {
      e.preventDefault();

      var $that = $(this);
      var $placeholder = $('.modal-content-placeholder');
      var href = $that.attr('href');

      // only handle the modal when there is an href to open
      if ((typeof href !== typeof undefined && href !== false) || $that.hasClass('modal-inline')) {
        // remove the previous iframe if present
        if ($placeholder.find('iframe')) {
          $placeholder.find('iframe').remove();
        }

        // are we using an iframe?
        if ($that.hasClass('modal-iframe')) {
          var width = $that.data('width');
          var height = $that.data('height');
          $placeholder.append('<iframe src="' + href + '" width="' + width + '" height="' + height + '"></iframe>');

          Modal.showModal();
        } else if ($that.hasClass('modal-inline')) {
          $placeholder.append($('#' + $that.data('modal')).clone().removeClass('hidden'));

          Modal.showModal($that.hasClass('do-focus-first'));
        } else {
          // get the html to be shown in the modal
          $.get(
            href,
            function (html) {
              $placeholder.html(html);

              Modal.showModal($that.hasClass('do-focus-first'));
            }
          );
        }
      }
    });

    // make sure that clicking on the content of the modal does not close the modal
    $(document).on('click', '.modal-centerer', function (e) {
      e.stopPropagation();
    });

    // close the modal when clicking outside the modal or on the close icon specificly
    $(document).on('click', '.modal-close-trigger, .modal-background', function (e) {
      e.stopPropagation();

      Modal.hideModal();
    });

    // see if the modal window still fits after resizing
    $(window).on('resize', function () {
      Modal.setModalPlaceholderDimensions();
    });
  },

  // show the modal
  showModal: function(doFocusFirst) {
    var $container = $('.modal-container');

    Modal.disableBodyScroll();

    $container.addClass('open').fadeIn('fast', function () {
      Modal.setModalPlaceholderDimensions();
      if (doFocusFirst) {
        $container.find('label input').first().focus();
      }
    });
  },

  // make sure the height of the modal fits the window
  setModalPlaceholderDimensions: function() {
    // prevent further execution if the modal is not open, as this will increase performance
    if (!$('.modal-container').hasClass('open')) {
      return;
    }

    var $window = $(window);
    var $placeholder = $('.modal-content-placeholder');
    var overlay_margin = 20;
    var max_placeholder_width = $window.width() - (overlay_margin * 2);
    var max_placeholder_height = $window.height() - (overlay_margin * 2);

    $placeholder.width('auto');
    if ($placeholder.outerWidth() > max_placeholder_width) {
      $placeholder.width(max_placeholder_width);
    }
    $placeholder.height('auto');
    if ($placeholder.outerHeight() > max_placeholder_height) {
      $placeholder.height(max_placeholder_height);
    }
  },

  // hide the modal
  hideModal: function () {
    Modal.enableBodyScroll();

    $('.modal-container').removeClass('open').fadeOut('fast');
    $('.modal-content-placeholder').empty();
  },

  customConfirm: function(title, content) {
    Modal.customAlert(title, content, true);
  },

  customAlert: function(title, content, showConfirm) {
    var $placeholder = $('.modal-content-placeholder');
    var $customAlert = $('#custom_alert');
    $customAlert.find('h1, p').remove();
    $customAlert.prepend('<h1></h1><p></p>');
    $customAlert.find('h1').text(title);
    $customAlert.find('p').text(content);

    if ( ! showConfirm) {
      $customAlert.find('.cancel-button').hide();
    }

    var html = $customAlert.clone().removeClass('hidden');

    $placeholder.append(html);

    Modal.showModal();
  },

  disableBodyScroll: function() {
    $('body').addClass('no-scroll');
  },

  enableBodyScroll: function() {
    $('body').removeClass('no-scroll');
  }
};

window.Modal = Modal;

Modal.init();

export default Modal;